/*eslint comma-dangle: [1, "always"]*/
export default {
  // Homepage
  'Terms And Conditions': 'Terms And Conditions',
  'Philips Sports Headphones and Wings for Life World Run Promotion': 'Philips Sports Headphones &<br>Wings for Life World Run Promotion',
  'Days for the race': 'Days for the race',
  'Terms & Conditions': 'Terms & Conditions',
  'Quick guide': 'Quick Guide',
  'How to participate?': 'How to participate?',
  'Buy one of the Philips Sound Sports products': 'Buy one of the Philips Sound Sports products',
  'Register your purchase by uploading your receipt or invoice': 'Register your purchase by uploading your receipt or invoice',
  'Receive an email with a Wings for Life World Run digital voucher code': 'Receive an email with a Wings for Life World Run digital voucher code',
  'Download the "Wings for Life World Run" app': 'Download the "Wings for Life World Run" app',
  'Create an account or log in at "Wings for Life World Run" (no costs involved) and redeem your digital voucher code': 'Create an account or log in at "Wings for Life World Run" (no costs involved) and redeem your digital voucher code',
  'Register': 'Register',
  'Careers': 'Careers',
  'Contact Philips': 'Contact Philips',
  'Cookie Notice': 'Cookie Notice',
  'Privacy Notice': 'Privacy Notice',
  'Terms of Use': 'Terms of Use',
  'days': 'days',
  'hrs': 'hrs',
  'mins': 'mins',

  // Receipt Upload page
  "Please select the product you've purchased and upload a clear picture of your receipt.": "Please select the product you've purchased and upload a clear picture of your receipt.",
  'Upload a receipt (pdf, jpg, png or tiff )': 'Upload a receipt (pdf, jpg, png or tiff )',
  'Select Receipt': 'Select Receipt',
  'Choose another Receipt': 'Choose another Receipt',
  'Upload a receipt': 'Upload a receipt',
  'Choose model number': 'Choose model number',
  'Back': 'Back',
  'Remove': 'Remove',
  'Processing': 'Processing',
  'Next': 'Next',
  'Get Voucher': 'Get Voucher',
  'Get Voucher For A Friend': 'Get Voucher For A Friend',
  'Make sure that the following information is clearly visible on your receipt:': 'Make sure that the following information is clearly visible on your receipt:',
  'Dealer / market': 'Dealer / market',
  'Date and time of purchase': 'Date and time of purchase',
  'Promotional product and purchase price': 'Promotional product and purchase price',
  'Total amount of the document': 'Total amount of the document',
  'Receipt number': 'Receipt number',
  'Select the file and upload your receipt': 'Select the file and upload your receipt',
  'Only pdf, jpg, png or tiff are supported. Maximum file size: 16 MB': 'Only pdf, jpg, png or tiff are supported. Maximum file size: 16 MB',
  'This file format is not supported. Only pdf, jpg, png or tiff files are accepted.': 'This file format is not supported. Only pdf, jpg, png or tiff files are accepted.',
  'This file is too big. Only files up to 16 MB can be uploaded.': 'This file is too big. Only files up to 16 MB can be uploaded.',
  'Please adjust the gray rectangle to the receipt.': 'Please adjust the gray rectangle to the receipt.',
  'Crop': 'Crop',
  'Rub out': 'Rub out',
  'Pull': 'Pull',
  'Zoom in': 'Zoom in',
  'Zoom out': 'Zoom out',
  "Your receipt is now being uploaded and processed.": 'Your receipt is now being uploaded and processed.',
  "The receipt will be processed automatically. This may take a minute. Please be patient.": 'The receipt will be processed automatically. This may take a minute. Please be patient.',
  "If you get an error message, please take a better version of the receipt and upload it again.": 'If you get an error message, please take a better version of the receipt and upload it again.',

  // Registration page
  'Please enter your personal details below': 'Please enter your personal details below',
  'Name': 'Name',
  'Surname': 'Surname',
  'Email': 'Email',
  'Country': 'Country',
  'Have you already signed up for the Wings for Life World Run 2022 edition ?': 'Have you already signed up for the Wings for Life World Run 2022 edition ?',
  'Yes': 'Yes',
  'No': 'No',
  'I confirm that I am over 18 years old. I have read and accept the terms and conditions.': 'I confirm that I am over 18 years old. I have read and accept the <a href="/terms?lang=en" target="_blank"><u>terms and conditions</u></a>.',
  'I would like to receive promotional communications - based on my preferences and behavior - about Philips products, services, events and promotions. I can easily unsubscribe at any time!': 'I would like to receive promotional communications - based on my preferences and behavior - about Philips products, services, events and promotions. I can easily unsubscribe at any time!',
  'What does this mean?': 'What does this mean?',
  'What does this mean text': `As a result of your consent, Philips group companies may contact you with promotional communications via email, SMS and other digital channels, such as mobile apps and social media.To be able to tailor the communications to your preferences and behavior and provide you with the best, personalized experience, we may analyze and combine your personal data. This data may include:
  <br>
  <br>
  Data you give us.
  <br>
  Data that you want to actively share with us such as: your name, date of birth or age, email address, physical address, country, gender, phone number, social media profile.
  <br>
  <br>
  Data we get from your interactions with Philips. Data about your interactions and usage of the Philips digital channels, such as social media, websites, emails, apps and connected products.This data may include: IP address, cookies, device information, communications you click on, location details, and websites you visit.
  <br>
  <br>
  Philips will give you the opportunity to withdraw your consent at any time. For more information, please read the <a href="https://www.tpvision.com/privacy-policy/" target="_blank"><u>Philips Privacy notice</u></a> and the <a href="https://www.philips.co.uk/a-w/cookie-notice.html" target="_blank"><u>Philips Cookie notice</u></a>.`,
  'Privacy link': '<a href="https://www.tpvision.com/privacy-policy/" target="_blank"><u></u></a>',
  'Cookie link': '<a href="" target="_blank"><u></u></a>',

  // Thank you page
  'Thank You!': 'Thank You!',
  'Reference Number:': 'Reference Number: <b>{0}</b>.',
  'Thank you for registering to the Philips Sports Headphones and Wings for Life World Run Promotion.': 'Thank you for registering to the Philips Sports Headphones and Wings for Life World Run Promotion.',
  'Your receipt and data have been successfully sent to us and will now be verified.': 'Your receipt and data have been successfully sent to us and will now be verified.',
  'As soon as we have verified your purchase and data, you will either receive a confirmation email, or an email with further questions(if your data was incomplete or was not correct).This can take up to 36 hours, we ask for your patience.': 'As soon as we have verified your purchase and data, you will either receive a confirmation email, or an email with further questions(if your data was incomplete or was not correct).This can take up to 36 hours, we ask for your patience.',
  'Back to home': 'Back to home',

  // DOI thank you
  'Thank you!': 'Thank you!',
  'Thank you for registering your Philips Sports Headphone product!  Now you can receive promotions, special offers, and news about future Philips products.': 'Thank you for registering your Philips Sports Headphone product!  Now you can receive promotions, special offers, and news about future Philips products.',

  // Reupload
  'Upload proof of purchase again': 'Upload proof of purchase again',
  'In this step, please upload the proof of purchase of your Philips Sports Headphones product!': 'In this step, please upload the proof of purchase of your Philips Sports Headphones product!',

  // Campaign is over page
  'The campaign period is unfortunately over': 'The campaign period is unfortunately over',
  'Thank you for your interest in the campaign, unfortunately the campaign period is over.': 'Thank you for your interest in the campaign, unfortunately the campaign period is over.',

  // Error messages
  'Internal server problems. Please be patient for a few minutes and then try again.': 'Internal server problems. Please be patient for a few minutes and then try again.',
  'There is a technical error. Please wait a moment and try again.': 'There is a technical error. Please wait a moment and try again.',
  'Oops. Something went wrong, please try again later.': 'Oops. Something went wrong, please try again later.',
  'Internal server error': 'Internal server error',
  'System error': 'System error',
  'No campaign defined with this ID': 'No campaign defined with this ID',
  'System processing error': 'System processing error',
  'Error': 'Error',
  'Back ': 'Back ',
  'Try again': 'Try again',
  'An error has occurred. Please update the website.': 'An error has occurred. Please update the website.',
  'Internal server problems - Currently our servers are overloaded due to a lot of requests. Please wait a few minutes and then try again.': 'Internal server problems - Currently our servers are overloaded due to a lot of requests. Please wait a few minutes and then try again.',
  'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.': 'This file format is not supported. Only .jpeg, .png, .pdf and .tiff files are accepted.',
  'There is currently a problem with our website. Please try again in a few minutes.': 'There is currently a problem with our website. Please try again in a few minutes.',

  // Validation
  validation: {
    name: 'Your first name and last name may only contain letters.',
    email: 'The email must be in correct format',
    required: 'Required',
    customRequired: {
      checkbox: 'Please check this box if you want to proceed',
      firstName: 'The First Name field is required',
      lastName: 'The Last Name field is required',
      email: 'The email field is required',
      modelNumber: 'Please select a model number',
      country: 'The country field is required',
      receipt: 'Please, upload a receipt',
    },
  },

  header_links: {
    terms: '/terms?lang=en',
    guide: '/quick-guide?lang=en',
  },
  home_link: '/?lang=en',

  footer_links: {
    career: 'https://www.careers.philips.com/emea/en',
    contact: 'https://www.philips.co.uk/c-w/support-home/support-contact-page.html',
    cookie: 'https://www.philips.co.uk/a-w/cookie-notice.html',
    privacy: 'https://www.tpvision.com/privacy-policy/',
    terms: 'https://www.philips.co.uk/a-w/terms-of-use.html',
  },
  '80': '80',
  '38': '38',
  '00': '00',
}
